import { delay, takeLatest, takeEvery, put, all, select, call, fork, take, cancelled } from "redux-saga/effects";
import 'ion-sound';

window.ion.sound({
  sounds: [
      {name: "chime"}
  ],
  path: "/build/sounds/",
  preload: true,
  multiplay: true,
  volume: 0.3
});

function fetchApiInit(cHash, uuid, tagId) {
  let url = '/widget/'+cHash + "/init?uuid="+uuid+'&tagId='+tagId;

  return fetch(url).then(response => response.json().catch(error => error).then((res) => {
    if(response.status != 200) {
      return error;
    }
    return res;
  }));
}

function fetchApiMessages(cHash, uuid, beforeId = null) {
  let url = '/widget/'+cHash + "/messages?uuid="+uuid;
  if (beforeId) {
    url = url + '?beforeId='+beforeId;
  }

  return fetch(url).then(response => response.json().catch(error => error).then((res) => {
    if(response.status != 200) {
      return error;
    }
    return res;
  }));
}

function postApiMessage(cHash, uuid, message, lastDate, files, email, pageUrl, browserLang, browserVersion, clientName, tagId)
{
  return fetch('/widget/'+cHash + "/message?uuid="+uuid, {
    method: 'post',
    body: JSON.stringify({
      message: message,
      lastDate: lastDate,
      files: files,
      email: email,
      name: clientName,
      pageUrl: pageUrl,
      browserLang: browserLang,
      browserVersion: browserVersion,
      tagId: tagId
    })
  }).then(response => response.json().catch(error => error).then((res) => {
    if(response.status != 200) {
      return error;
    }
    return res;
  }));
}

function postTalkToHuman(cHash, uuid)
{
  return fetch('/widget/'+cHash + "/talk-to-human?uuid="+uuid, {
    method: 'post'
  }).then(response => response.json().catch(error => error).then((res) => {
    if(response.status != 200) {
      return error;
    }
    return res;
  }));
}

function postActionButtonClicked(cHash, uuid, id)
{
  return fetch('/widget/'+cHash + "/action-button/"+id+"?uuid="+uuid, {
    method: 'post'
  }).then(response => response.json().catch(error => error).then((res) => {
    if(response.status != 200) {
      return error;
    }
    return res;
  }));
}

function postApiReded(cHash, uuid, date)
{
  return fetch('/widget/'+cHash + "/readed?uuid="+uuid, {
    method: 'post',
    body: JSON.stringify({
      date: date
    })
  }).then(response => response.json().catch(error => error).then((res) => {
    if(response.status != 200) {
      return error;
    }
    return res;
  }));
}

export const watchInitWidget = function* change() {
  yield takeEvery('INIT_WIDGET', function*(action) {

    const getCHash = (state) => state.app.cHash;
    const cHash = yield select(getCHash);

    const getTagId = (state) => state.app.tagId;
    const tagId = yield select(getTagId);

    try {
      const init = yield call(fetchApiInit, cHash, action.uuid, tagId);
      yield put({ type: 'INIT_SUCCESS', config: init });
    } catch (error) {
      yield put({ type: 'INIT_FAILED' });
    }
  });
};

export const watchActionButtonClick = function* change() {
  yield takeLatest('ACTION_BUTTON_CLICKED', function*(action){
    const getCHash = (state) => state.app.cHash;
    const cHash = yield select(getCHash);

    const getUuid = (state) => state.uuid.uuid;
    const uuid = yield select(getUuid);

    try {
      yield call(postActionButtonClicked, cHash, uuid, action.id);
      yield put({ type: 'ACTION_BUTTON_CLICKED_SUCCESS' });
    } catch (error) {
      console.log(error);
      yield put({ type: 'ACTION_BUTTON_CLICKED_FAILED' });
    }
  });
};

export const watchTalkToHuman = function* change() {
  yield takeEvery('TALK_TO_HUMAN', function*(action){
    const getCHash = (state) => state.app.cHash;
    const cHash = yield select(getCHash);

    const getUuid = (state) => state.uuid.uuid;
    const uuid = yield select(getUuid);

    try {
      yield call(postTalkToHuman, cHash, uuid);
      yield put({ type: 'TALK_TO_HUMAN_SUCCESS' });
    } catch (error) {
      console.log(error);
      yield put({ type: 'TALK_TO_HUMAN_FAILED' });
    }
  });
};

export const watchReadMessages = function* change() {
  yield takeEvery('READ_MESSAGES', function*(action){
    const getCHash = (state) => state.app.cHash;
    const cHash = yield select(getCHash);

    const getUuid = (state) => state.uuid.uuid;
    const uuid = yield select(getUuid);

    const getMessages = (state) => state.app.messages;
    const messages = yield select(getMessages);

    const getShowWidget = (state) => state.launcher.showWidget;
    const showWidget = yield select(getShowWidget);

    if (!showWidget) {
      return;
    }

    try {
      yield call(postApiReded, cHash, uuid, messages[messages.length - 1].date);
      yield put({ type: 'READ_MESSAGES_SUCCESS' });
    } catch (error) {
      console.log(error);
      yield put({ type: 'READ_MESSAGES_FAILED' });
    }
  });
};

export const watchLoadMessagesDivWidget = function* change() {
  yield takeEvery('LOAD_MESSAGES_DIV_WIDGET', function*(action){

    const getIsDivWidget = (state) => state.launcher.isDivWidget;
    const isDivWidget = yield select(getIsDivWidget);

    if (!isDivWidget) {
      return;
    }

    yield put({ type: 'LOAD_MESSAGES' });

  });
};

export const watchLoadMessages = function* change() {
  yield takeEvery('LOAD_MESSAGES', function*(action){

    const getCHash = (state) => state.app.cHash;
    const cHash = yield select(getCHash);

    const getUuid = (state) => state.uuid.uuid;
    const uuid = yield select(getUuid);

    const getIsClient = (state) => state.app.isClient;
    const isClient = yield select(getIsClient);

    if (!isClient) {
      return;
    }

    try {
      const messages = yield call(fetchApiMessages, cHash, uuid);
      yield put({ type: 'LOAD_MESSAGES_SUCCESS', messages: messages.data, operator: messages.operator });
      if (messages.data.length) {
        yield call(postApiReded, cHash, uuid, messages.data[messages.data.length - 1].date);
      }
    } catch (error) {
      console.log(error);
      yield put({ type: 'LOAD_MESSAGES_FAILED' });
    }
  });
};

export const watchSendMessage = function* change() {
  yield takeEvery('SEND_MESSAGE', function*(action){
    
    const getCHash = (state) => state.app.cHash;
    const cHash = yield select(getCHash);

    const getUuid = (state) => state.uuid.uuid;
    const uuid = yield select(getUuid);

    let email = ("email" in action) ? action.email : null;

    const getTagId = (state) => state.app.tagId;
    const tagId = yield select(getTagId);

    const getBrowserLang = (state) => state.app.browserLang;
    const browserLang = yield select(getBrowserLang);

    const getBrowserVersion = (state) => state.app.browserVersion;
    const browserVersion = yield select(getBrowserVersion);

    const getPageUrl = (state) => state.app.pageUrl;
    const pageUrl = yield select(getPageUrl);

    const getClientName = (state) => state.app.clientName;
    const clientName = yield select(getClientName);

    const getClientEmail = (state) => state.app.clientEmail;
    const clientEmail = yield select(getClientEmail);

    if (clientEmail) {
      email = clientEmail;
    }

    try {
      const message = yield call(postApiMessage, cHash, uuid, action.message, action.lastDate, action.files, email, pageUrl, browserLang, browserVersion, clientName, tagId);
      yield put({ type: 'SEND_MESSAGE_SUCCESS', message: message });

      if ("email" in action) {
        yield put({ type: 'SET_IS_CLIENT' });
        yield put({ type: 'LOAD_MESSAGES' });
      }

    } catch (error) {
      yield put({ type: 'SEND_MESSAGE_FAILED', message: error.message });
    }
  })
}

export const watchNewMessage = function* change() {
  yield takeEvery('NEW_MESSAGE', function*(action) {

    if (action.payload.message.fromClient) {
      return;
    }

    window.ion.sound.play("chime");
  });
};